import { faBuilding as faBuildingOutline } from '@fortawesome/free-regular-svg-icons'
import { faBuilding, faBullhorn } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Group, Indicator, Text, UnstyledButton } from '@mantine/core'
import classes from '../css/ModeToggleButton.module.css'

interface ModeToggleButtonProps {
  isHostMode: boolean
  setIsHostMode: (isHostMode: boolean) => void
  pendingCount?: number
}
export const ModeToggleButton = ({
  isHostMode,
  setIsHostMode,
  pendingCount = 0,
}: ModeToggleButtonProps) => {
  return (
    <div className={classes.modeToggleContainer}>
      <UnstyledButton
        className={
          isHostMode
            ? `${classes.modeToggleButton} ${classes.selected}`
            : `${classes.modeToggleButton} ${classes.unselected}`
        }
        fz={12}
        onClick={() => setIsHostMode(true)}
        type='button'
        aria-label='Host'
      >
        <Group gap={8} wrap='nowrap'>
          <Indicator
            disabled={pendingCount === 0}
            size={8}
            color='red'
            withBorder
            position='top-end'
          >
            <FontAwesomeIcon
              icon={isHostMode ? faBuilding : faBuildingOutline}
            />
          </Indicator>
          <Text fz={10}>Host</Text>
        </Group>
      </UnstyledButton>
      <UnstyledButton
        className={
          !isHostMode
            ? `${classes.modeToggleButton} ${classes.selected}`
            : `${classes.modeToggleButton} ${classes.unselected}`
        }
        onClick={() => setIsHostMode(false)}
        type='button'
        aria-label='Advertiser'
      >
        <Group gap={8} wrap='nowrap'>
          <Text fz={10}>Advertiser</Text>
          <FontAwesomeIcon
            size='xs'
            icon={faBullhorn}
            style={{
              opacity: !isHostMode ? 1 : 0.4,
              filter: !isHostMode ? 'none' : 'grayscale(1)',
            }}
          />
        </Group>
      </UnstyledButton>
    </div>
  )
}
